import { Button } from "@motleyhand/design"
import { useResendVerifyEmail } from "@/profile"

export default function RequestVerifyEmail() {
  const resendEmail = useResendVerifyEmail()

  return (
    <div>
      <p className="mb-4">
        In order to activate your account, you need to verify your email
        address. You may request a new confirmation email.
      </p>
      <Button variant="ghost" onClick={resendEmail}>
        Re-send confirmation email
      </Button>
    </div>
  )
}
